import { render } from "./active-dashboards-overview.vue?vue&type=template&id=40e0a0a0&ts=true"
import script from "./active-dashboards-overview.ts?vue&type=script&lang=ts&external"
export * from "./active-dashboards-overview.ts?vue&type=script&lang=ts&external"

import "./active-dashboards-overview.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__